var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('data-table',{attrs:{"tableId":"main_acc_list","header":this.tableHeader,"columns":this.tableColumns,"columnDefs":this.columnDefs,"columnSearch":this.columnSearch,"data":this.users,"drawCallback":this.openEditAccount}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }